import type { PropsWithChildren } from 'react';

import type { BoxProps } from '@mantine/core';
import { Group, Text } from '@mantine/core';

import { getSx } from '../../../../../../shared/utils/sx';

interface TabProps extends PropsWithChildren {
  containerProps?: BoxProps;
  label?: string;
  isActive?: boolean;
  tabId: string;
  onClick?: (id: string) => void;
}

export function Tab({
  containerProps = {},
  label,
  tabId,
  onClick,
  children,
  isActive,
}: TabProps) {
  const { sx: containerSx = [], ...restContainerProps } = containerProps;

  function handleClick() {
    onClick?.(tabId);
  }

  return (
    <Group
      px="03"
      py="02"
      spacing={'01'}
      data-tab-id={tabId}
      onClick={handleClick}
      {...restContainerProps}
      sx={[
        {
          borderRadius: 100,
          overflow: 'hidden',
          position: 'relative',
          cursor: 'pointer',
        },
        ...getSx(containerSx),
      ]}
    >
      <Text
        size="sm"
        fw={500}
        color={isActive ? 'white' : 'black'}
        sx={{
          transition: 'all 0.2s cubic-bezier(0.40,0.00,1.00,1.00)',
        }}
      >
        {children || label}
      </Text>
    </Group>
  );
}
